export default "__VITE_ASSET__bd12ba86__"